import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit'
import client from '../api/client'
import { RootState } from '../app/store'
import { FetchStatus } from '../pages/live/types'
import { sportBonusSampleData } from '../pages/live/sampleData'
import { ENV } from '../app/const'

const initialState = {
  bonusAmount: "0",
  ticketCount: 0,
  status: 'idle' as FetchStatus,
}

export const fetchSportBonus = createAsyncThunk(
  'sport/fetchSportBonus',
  async () => {
    if (ENV === 'development') {
      return await JSON.parse(sportBonusSampleData) 
    } else {
      const response = await client.post(
        '/Mobile/Pages/LiveGames.aspx/GetBonusProgress',
        {}
      )
      return (await JSON.parse(response.data.d)) 
    }
  }
)

export const sportBonusSlice = createSlice({
  name: 'sportBonus',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchSportBonus.pending, (state) => {
        state.status = 'loading'
      })
      .addCase(
        fetchSportBonus.fulfilled,
        (state, action: PayloadAction<any>) => {
          state.status = 'succeeded'
          const { bonusAmount, ticketCount } = action.payload;
          state.bonusAmount = bonusAmount
          state.ticketCount = ticketCount
        }
      )
      .addCase(fetchSportBonus.rejected, (state) => {
        state.status = 'failed'
      })
  },
})


export const selectBonusAmount = (state: RootState) => state.sportBonus.bonusAmount
export const selectSportTypes = (state: RootState) => state.sportBonus.ticketCount
export const selectSportBonusStatus = (state: RootState) => state.sportBonus.status
export default sportBonusSlice.reducer
